module.exports = __webpack_public_path__ + "img/device_offline.c1109f1e.png";